export default __webpack_public_path__ + "locales/tariff.kk.json";